export const environment = {
  production: true,
  apiUrl: 'https://api.comunidades.lec.digital/api/v1'
};